import { render, staticRenderFns } from "./TruckParkingsBundle.vue?vue&type=template&id=100990f0"
import script from "./TruckParkingsBundle.vue?vue&type=script&lang=js"
export * from "./TruckParkingsBundle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports